import { render, staticRenderFns } from "./addgiftlist.vue?vue&type=template&id=48e6986c&scoped=true"
import script from "./addgiftlist.vue?vue&type=script&lang=js"
export * from "./addgiftlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6986c",
  null
  
)

export default component.exports